angular.module('edxComponents').filter('domainText', [
  'translateFilter',
  function (translateFilter) {

    // Each AST maps to an ordered list of steps applied to the text.
    // A step is either { phrase, to } (a literal phrase replace()) or
    // { tier, to } (a domain/cluster/standard tier replace). Order matters -
    // e.g. "a Standard or Cluster" must be replaced before the shorter
    // "Standard or Cluster" phrase it contains.

    var STRAND_STEPS = [
      { tier: "domain", to: "Strand" }
    ];

    var UNIT_STANDARD_STEPS = [
      { tier: "domain", to: "Unit" },
      { tier: "standard", to: "Unit" }
    ];

    var ENGAGENY_EUREKA_STEPS = [
      { phrase: "clusters and individual standards", to: "topics" },
      { phrase: "Standard or Cluster", to: "Topic" },
      { tier: "domain", to: "Module" },
      { tier: "standard", to: "Topic" }
    ];

    var CFLM_STEPS = [
      { phrase: "Standard or Cluster", to: "Unit" },
      { tier: "standard", to: "Unit" }
    ];

    var TIER_DESCRIPTIONS = {
      wnlp: STRAND_STEPS,
      ontario: STRAND_STEPS,
      minnesota_2022: STRAND_STEPS,
      sol_2016: [
        { phrase: "clusters and individual standards", to: "individual standards" },
        { phrase: "Standard or Cluster", to: "Standard" }
      ],
      teks: [
        { tier: "domain", to: "Focal Area" }
      ],
      gomath: [
        { tier: "domain", to: "Chapter" },
        { tier: "standard", to: "Chapter" }
      ],
      gomath_2023: [
        { phrase: "Standard or Cluster", to: "Chapter" },
        { tier: "domain", to: "Volume" },
        { tier: "standard", to: "Chapter" }
      ],
      dbl: [
        { phrase: "clusters and individual standards", to: "individual lesson groups" },
        { phrase: "a Standard or Cluster", to: "Lesson Group" },
        { phrase: "Standard or Cluster", to: "Lesson Group" },

        // need to replace pluralized version first since we can't just let it end up as categorys
        { phrase: "Domains", to: "Categories" },
        // plural domains should be gone, so this should only affect the singular version
        { tier: "domain", to: "Category" },

        // this also handles the plural "standards" since "lesson group" is also pluralized with "s"
        { tier: "standard", to: "Lesson Group" }
      ],
      engageNY: ENGAGENY_EUREKA_STEPS,
      eureka: ENGAGENY_EUREKA_STEPS,
      cflm: CFLM_STEPS,
      cflm_2021: CFLM_STEPS,
      envmath2: [
        { phrase: "clusters and individual standards", to: "lessons" },
        { phrase: "Standard or Cluster", to: "Lesson" },
        { tier: "domain", to: "Topic" },
        { tier: "standard", to: "Lesson" }
      ],
      origo: [
        { phrase: "clusters and individual standards", to: "topics" },
        // FYI: Origo flips the standard or lesson placement when replaced
        { phrase: "Standard or Cluster", to: "Lesson or Step" },
        { tier: "domain", to: "Module" },
        { tier: "cluster", to: "Lesson" },
        { tier: "standard", to: "Step" }
      ],
      mathexpressions: [
        { phrase: "clusters and individual standards", to: "big ideas and individual lessons" },
        { tier: "domain", to: "Unit" },
        { tier: "cluster", to: "Big Idea" },
        { tier: "standard", to: "Lesson" }
      ],
      bridges: [
        { phrase: "clusters and individual standards", to: "modules and individual lessons" },
        { tier: "domain", to: "Unit" },
        { tier: "cluster", to: "Module" },
        { tier: "standard", to: "Session" }
      ],
      everydaymath_4th: UNIT_STANDARD_STEPS,
      everydaymath_3rd: UNIT_STANDARD_STEPS,
      illustrative_math: UNIT_STANDARD_STEPS,
      investigations: [
        { phrase: "a Standard or Cluster", to: "an Investigation" },
        { phrase: "Standard or Cluster", to: "Investigation" },
        { tier: "domain", to: "Unit" },
        { tier: "cluster", to: "Investigation" },
        { tier: "standard", to: "Investigation" }
      ]
    };

    return function (text, ast) {

      if (_.isString(text)) {
        // Try curriculumData namespace first
        var curriculumTranslation = translateFilter('curriculumData.' + text, {defaultValue: null});
        if (curriculumTranslation) {
          return curriculumTranslation;
        }

        // Then fall back to domainText namespace
        text = removeDomainPrepend(text, ast);
        text = replaceTierDescriptions(text, ast);

        return translateFilter('domainText.' + text.toLowerCase(), {defaultValue: text});
      }

      return '';
    };

    function removeDomainPrepend(text, ast) {
      // In most cases we want to remove "Cluster:" or "Standard:" in drop downs for assignment creation.
      // Any AST/ABP that will retain the prepend should be added to the ignore list

      var ignore = ["origo"];

      if (ignore.indexOf(ast) === -1) {
        text = replace(text, "Cluster:", "");
        text = replace(text, "Standard:", "");
      }

      return text;
    }

    function replaceTierDescriptions(text, ast) {
      var steps = TIER_DESCRIPTIONS[ast];

      if (!steps) {
        return text;
      }

      return steps.reduce(function (result, step) {
        if (step.phrase) {
          return replace(result, step.phrase, step.to);
        }

        return applyTierReplace(result, step.tier, step.to);
      }, text);
    }

    function applyTierReplace(str, tier, replaceValue) {
      switch (tier) {
        case "domain":
          return domainReplace(str, replaceValue);
        case "cluster":
          return clusterReplace(str, replaceValue);
        case "standard":
          return standardReplace(str, replaceValue);
      }

      return str;
    }

    function domainReplace(str, replaceValue) {
      return str.replace(/Domain/g, replaceValue)
        .replace(/domain/g, replaceValue.toLowerCase())
        .replace(/DOMAIN/g, replaceValue.toUpperCase());
    }

    function clusterReplace(str, replaceValue) {
      return str.replace(/Cluster/g, replaceValue)
        .replace(/cluster/g, replaceValue.toLowerCase())
        .replace(/CLUSTER/g, replaceValue.toUpperCase());
    }

    function standardReplace(str, replaceValue) {
      return str.replace(/Standard/g, replaceValue)
        .replace(/standard/g, replaceValue.toLowerCase())
        .replace(/STANDARD/g, replaceValue.toUpperCase());
    }

    //General replace, can use regexp - which is too slow to use for everything :(
    function replace(str, searchValue, replaceValue) {
      return str.replace(new RegExp(searchValue, 'g'), replaceValue)
        .replace(new RegExp(searchValue.toLowerCase(), 'g'), replaceValue.toLowerCase())
        .replace(new RegExp(searchValue.toUpperCase(), 'g'), replaceValue.toUpperCase());
    }
  }
]);
